import {Button, Flex, Icon, PriorityIcon, Separator} from '@priority-software/priority-style-react';
import React from 'react';
import styles from './styles.module.scss';
import helpTexts from '../../../_shared/Help/texts';

interface Props {
    onHelp: (e) => void;
    withText?: boolean;
    componentClasses?: string;
}
export const CloseWithHelp = ({onHelp, withText, componentClasses}: Props) => {
    const handleHelp = e => {
        e.stopPropagation();
        onHelp(e);
    };
    return (
        <Flex
            style={{zIndex: 1}}
            alignItems="center"
            justifyContent="flex-start"
            componentClasses={componentClasses}
        >
            {withText ? (
                <Button skin="text" onClick={handleHelp} prefixIcon={PriorityIcon.help}>
                    {helpTexts.help}
                </Button>
            ) : (
                <Icon icon={PriorityIcon.help} skin="standart" onClick={handleHelp} />
            )}
            <Separator componentClasses={styles.helpSeparator} height={25} />

            <Icon icon={PriorityIcon.x} hoverable skin="standart" />
        </Flex>
    );
};
